<template>
    <div class="p-4 lg:w-full md:w-full">
        <div class="grid grid-cols-1 gap-4">
            <!-- <div class="field w-full mb-4 flex items-center">
                <JetLabel
                    class="w-1/3 my-2"
                    for="total_hps"
                    value="Debug"
                />
                <div id="total_hps" class="p-2 border rounded-md w-2/3">
                    {{ dataViewDokumenPengadaan.config }}
                    <br />
                    {{ dataViewDokumenPengadaan.tahap }}
                    <br />
                    {{ dataViewDokumenPengadaan.paket_pengadaan }}
                </div>
            </div> -->
            <div
                v-if="
                    dataViewDokumenPengadaan.config.includes('paket_pengadaan')
                "
                class="field w-full mb-4 flex items-center"
            >
                <JetLabel
                    class="w-1/3 my-2"
                    for="paket_pengadaan"
                    value="Paket Pengadaan"
                />
                <div id="paket_pengadaan" class="p-2 border rounded-md w-2/3">
                    <ul class="list-disc pl-5">
                        <li>
                            <strong>Nama Paket Pengadaan:</strong>
                            {{
                                dataViewDokumenPengadaan.paket_pengadaan
                                    .nama_paket_pengadaan
                            }}
                        </li>
                        <li>
                            <strong>Kategori Pengadaan:</strong>
                            {{
                                dataViewDokumenPengadaan.paket_pengadaan
                                    .kategori_pengadaan
                            }}
                        </li>
                        <li>
                            <strong>Pagu Anggaran:</strong>
                            {{
                                dataViewDokumenPengadaan.paket_pengadaan
                                    .pagu_anggaran
                            }}
                        </li>
                        <li>
                            <strong>Ruang Lingkup:</strong>
                            {{
                                dataViewDokumenPengadaan.paket_pengadaan
                                    .ruang_lingkup_pengadaan
                            }}
                        </li>
                        <li v-if="dataViewDokumenPengadaan.paket_pengadaan.metode_pemilihan === 1">
                            <strong>Metode Pemilihan:</strong>
                            Tender
                        </li>
                        <li v-if="dataViewDokumenPengadaan.paket_pengadaan.metode_pemilihan === 2">
                            <strong>Metode Pemilihan:</strong>
                            Pengadaan Langsung
                        </li>
                        <li v-if="dataViewDokumenPengadaan.paket_pengadaan.metode_pemilihan === 3">
                            <strong>Metode Pemilihan:</strong>
                            Penunjukan Langsung
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import JetLabel from "@/Jetstream/Label";

export default defineComponent({
    props: {
        dataViewDokumenPengadaan: Object,
    },
    components: {
        JetLabel,
    },
});
</script>
